import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { ALK_EVENT_TYPE, BATCH_KIND, LocalMatrixCommand, MatrixCall, MultiDisplay, MultiDisplayConfig, PermissionAccess, 
  PermissionVisibility, StaticFeatureEnum, ViewData } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { FilterComponent, WizAgGrid, WizDatasource, WizEvent, WizEventManager, WizGroupCommand, WizIcon, WizLabel, WizNumericInput, WizRoot, WizTextarea, WizTextInput, WizValidationContainerDirective, WizVgroup } from '@wizeoo/akm-component-lib';
import { Model } from '../../model/model';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { MatrixCallParam, MatrixVO } from '@wizeoo/akm-compute-lib';
import { ColDef, GridOptions } from 'ag-grid-community';

/**
 * Vue de gestion des matrices de données
 */
@Component({
  selector: 'matrix-view',
  templateUrl: './matrix.view.html',
})
export class MatrixView extends BaseView {

  @ViewChild('mdMain') mdMain: MultiDisplay<MatrixVO>; // grid principal
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon, static: false }) btnExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon, static: false }) btnImport: WizIcon;
  /** Bouton de suppression */
  // @ViewChild('btnRemove', { read: WizIcon, static: false }) btnDelete: WizIcon;
  // /** Bouton d'ajout */
  // @ViewChild('btnCreate', { read: WizIcon }) btnCreate: WizIcon;
  /** Bouton d'annulation */
  // @ViewChild('btnCancel', { read: WizButton }) btnCancel: WizButton;
  @ViewChild('vgEdition', { read: WizVgroup }) vgEdition: WizVgroup; // ensemble de la zone de détail pour écoute ModelUpdate
  @ViewChild('vgEdition', { read: WizValidationContainerDirective, static: false })
  private vgEditionCheck: WizValidationContainerDirective; // Zone de validation globale
  @ViewChild('tiCode', { read: WizTextInput }) tiCode: WizTextInput; // champ de saisie du code
  @ViewChild('tiVersion', { read: WizTextInput }) tiVersion: WizTextInput; // champ de saisie du code
  @ViewChild('tiRowCount', { read: WizTextInput }) tiRowCount: WizTextInput; // champ de saisie du code
  // @ViewChild('trsLabel', { read: WizTranslationBasic }) trsLabel: WizTranslationBasic; // libellé traduit
  // @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic; // description
  @ViewChild('agGrid') agGrid: WizAgGrid<any>; // grid
  @ViewChild('taQuery', { read: WizTextarea }) taQuery: WizTextarea; // champ requête (filter)
  @ViewChild('niField', { read: WizNumericInput }) niField: WizNumericInput; // champ cible
  @ViewChild('resultLbl', { read: WizLabel }) resultLbl: WizLabel; // valeur du résultat


  public currentMatrix: MatrixVO = null; // sélection active (objet métier vrai)
  public clone: MatrixVO = null; // clone de travail

  /** Constructeur */
  constructor(public elementRef: ElementRef, public cdRef: ChangeDetectorRef) {
    super(elementRef);
  }

  /** DS du grid principal */
  public mainDS: WizDatasource<MatrixVO> = new WizDatasource<MatrixVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();


  /** Configuration du mode multi display (principal) */
  public mainConfig: MultiDisplayConfig<MatrixVO> = {
    model: Model.getInstance(),
    datasource: this.mainDS,
    defaultMode: 'grid',
    onSelectionChanging: this.askSelectMain.bind(this),
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.code.$', flex: 1, sortable: true, resizable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.common.version.$', width: 60, sortable: true, resizable: true, field: 'version', tooltipField: 'version' },
      ],
    },
    filter: {
      enabled: true,
      initFilter: this.initMainFilter.bind(this),
    },
  };

  /* #############################################################
                      CYCLE DE VIE
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const commands = [];
    // chargement de la liste des matrices de données
    if (!Model.getInstance().matrixEngine.getMatrixList()) {
      // commands.push(new MatrixCommand(Model.getInstance()).find());
      commands.push(new MatrixCall(Model.getInstance()));
    }


    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands, null, false);
    } else {
      return null;
    }
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {

    super.managePermissions([
      {
        feature: StaticFeatureEnum.MATRIX,
        permissions: [
          // {
          //   component: this.btnCreate,
          //   accesses: [PermissionAccess.CREATE],
          //   visibility: PermissionVisibility.DISABLED,
          // },
          // {
          //   component: this.btnDelete,
          //   accesses: [PermissionAccess.DELETE],
          //   visibility: PermissionVisibility.DISABLED,
          // },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.mainFilter.configure(['code'], null, null); // alimentation du filtre principal
    this.mainDS.setSource(Model.getInstance().matrixEngine.getMatrixList()); // alimentation de la liste principale
    this.mainDS.refresh();
    this.tiCode.wizRestrict = ViewData.ALPHANUMERIC_REGEXP;
    // this.feed();
  }

  /** alimentation de la zone de détail */
  private feed(): void {

    this.vgEdition.visible = !!this.clone;

    if (!!this.clone) {
      this.tiCode.wizValue = this.clone.code; // alimentation du code
      this.tiVersion.wizValue = this.clone.version; 
      this.tiRowCount.wizValue = this.clone.rowCount;

      let cols: ColDef[] = [];
      let idx: number = 0;
      Object.keys(this.clone.columns).forEach(key => {
        let col: ColDef = 
        {
          headerName: "("+ idx + ") " + this.clone.columns[key],
          field: key,
          width: 100,
          sortable: true,
          resizable: true
        }
        idx++;
        cols.push(col);
      });
      this.columns = cols;

      let rows: any[] = this.clone.rows; // rows en local, déjà objet... JSON.parse(this.clone.rows);
      this.matrixDS.setSource(rows);
      
      // console.log('col & row', this.columns, this.matrixDS);
      // console.log('col & row', this.clone.rows);
      setTimeout(() => {
        this.agGrid.api.sizeColumnsToFit();
      }, 0);
      


    }
  }

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    super.wizAddListener();
    // WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    // WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
  }

  /* #############################################################
                  gestion sélection et filtres
     ############################################################# */

  private mainFilter: FilterComponent; // filterCompo du mdMain
  /** init du filter du mdMain */
  private initMainFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /** demande de changement de sélection */
  private askSelectMain(e: WizEvent = null): void {
    const vo: MatrixVO = e.value;
    if (!this.mainDS.isSelected(vo)) {
      // pas encore sélectionné
      this.doSelect(vo);
    } else {
      // déjà sélectionné, déselection
      this.doSelect(null);
    }
    
  }


  /**
   * Changement de matrice de données
   * @param pEvent WizEvent
   */
  private doSelect(vo: MatrixVO) {

    if (vo) {
      let cmd =  new LocalMatrixCommand(this.model).getLocal(vo, this.realySelect.bind(this));
      if(vo.loaded) {
        cmd.matrix = vo;
        this.realySelect(cmd);
      } else {
        new LocalMatrixCommand(this.model).getLocal(vo, this.realySelect.bind(this)).execute();
      }
    } else {
      this.currentMatrix = null;
      this.clone = null;
      this.feed();
    }
    
  }

  private realySelect(cmd: LocalMatrixCommand): void {
    this.currentMatrix = cmd.matrix;
    this.clone = Model.getInstance().matrixEngine.clone(this.currentMatrix);
    this.feed();
  }

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.MATRIX);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.MATRIX);
        break;
    }
  }

  /** callback sur retour d'import : recharger les matrices de données */
  private backFromImport(e: AlkEvent): void {
    // Juste besoin de rafraichir les données spécifiques au domain/bu courant
    if (e && e.data === BATCH_KIND.MATRIX) {
      this.model.matrixSyncService.resetAll();
      new MatrixCall(Model.getInstance(), this.backFromReload.bind(this)).execute();
      // new MatrixCommand(Model.getInstance()).find().configure(this.backFromReload.bind(this)).execute();
    }
  }

  private backFromReload(e: any): void {
    this.wizSynchronizeData();
  }

  /** définition des colonnes du grid */
  public columns: (ColDef)[] = null;
  
  /** configuration de l'agGrid */
  gridOptions: GridOptions = {
  };

  /**
   * datasource
   */
  public matrixDS: WizDatasource<any> = new WizDatasource<any>([])
    .setItemCodeField('key')
    .setSelectionMode('single')
    .build();

  private baseQuery: string = "db.table('matrixdata').where('key').equals('##INJECT##')";
  // exemple pour inject: 
  // filter(x => x[2] === 'Uni nouveauté' && x[1] === '01/09/2027' && x[4]?.toUpperCase().includes('SI'))

  private toArr: string = 'toArray()';
  public result: MatrixCallParam;

  public unrun(): void {
    let rows: any[] = this.clone.rows; // rows en local, déjà objet... JSON.parse(this.clone.rows);
    this.matrixDS.setSource(rows);
    this.resultLbl.wizLabel = '';
    this.cdRef.markForCheck();
  }


  public async run() {
    try {
      let parts: string[] = [this.baseQuery.replace('##INJECT##', this.currentMatrix.code)];
      if(!!this.taQuery.wizValue) {
        parts.push(this.taQuery.wizValue);
      }
      parts.push(this.toArr);
      
      this.result = await this.model.matrixEngine.runQuery(null, null, null, parts.join("."));
      // console.log('mv', this.result);
      this.matrixDS.setSource(this.result.result);

      if(!!this.niField.wizValue && this.result.result?.length > 0) {
        
          this.resultLbl.wizLabel = this.result.result[0][this.niField.wizNumber.toString()];
      } else {
        this.resultLbl.wizLabel = '';
      }

      this.cdRef.markForCheck();
    } catch (e) {
      console.log('run error', e);
      this.result = null;
    }
  }


}
